import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import { VENDOR_TERM_LINK } from './types';
import { getVendorDetailsByProductKey } from '../../api/marketplace';

export const fetchVendorTerms =
  (productKey: string) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(VENDOR_TERM_LINK, getVendorDetailsByProductKey(productKey, getState()), {
        productKey,
      }),
    );
  };
